export const locationOptionsPossibleValues = [
  { id: 'on_site', slug: 'on_site' },
  { id: 'hybrid', slug: 'hybrid' },
  { id: 'remote', slug: 'remote' },
]

export const jobTypesPossibleValues = [
  { id: 'full_time', slug: 'full_time' },
  { id: 'part_time', slug: 'part_time' },
  { id: 'free', slug: 'free' },
  { id: 'intern', slug: 'intern' },
  { id: 'working_student', slug: 'working_student' },
]

export const jobSearchStatusPossibleValues = [
  { id: 'actively_looking', slug: 'actively_looking' },
  { id: 'open_to_conversations', slug: 'open_to_conversations' },
  { id: 'not_looking', slug: 'not_looking' },
]

export const experiencePossibleValues = [
  { id: 'junior', slug: 'junior' },
  { id: 'novice', slug: 'novice' },
  { id: 'professional', slug: 'professional' },
  { id: 'senior', slug: 'senior' },
]

export const JOB_FEATURE = {
  TOP_JOB: 'top_job',
  SOCIAL_MEDIA_PUSH: 'social_media_push',
  REFRESH_HALFTIME: 'refresh_halftime',
  REFRESH_30: 'refresh_30',
  HIGHLIGHTING: 'highlighting',
}

export const JOB_OFFER_TYPE = {
  STANDARD: 'standard',
  INTERNSHIP: 'internship',
}

export const JOB_OFFER_LEVEL = {
  BASIC: 'basic',
  STARTER: 'starter',
  PREMIUM: 'premium',
}
